import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Footer from './components/Footer/Footer';
import Portfolio from './components/Portfolio/Portfolio';
import Contact from './components/Contact/Contact';
import ScrollUp from './components/ScrollUp/ScrollUp';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

const App = () =>{
  return(
    <>
    <Header />

    <main className='main'>
      <Home/>
      <About />
      <Skills />
      <Portfolio />
      <Contact />
    </main>
    <SpeedInsights/>
    <Analytics/>
    <ScrollUp/>
    <Footer />
    </>
  )
}

export default App;
